import type { AvailabilityApi } from '@/v2/services/availability/types';
import React from 'react';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import PackageHeroSummary from '@/components/PackageHeroSummary';
import { PackagePagePriceWithPointsPlusPaySlider } from '@/v2/components/pages/PackageView/components/PackagePagePrice';
import PriceContainer from '@/v2/components/pages/PackageView/components/RoomOptions/components/RoomOption/components/CTA/components/PriceContainer';

export type OfferPriceProps = {
  offer: AvailabilityApi.ParsedResponse.Offer;
  includeDivider?: boolean;
};

const OfferPrice = ({ offer, includeDivider }: OfferPriceProps) => {
  const { charges } = offer;
  const { searchQuery } = useSearchQuery();
  const { children, adults, infants } = searchQuery || {};

  return (
    <PriceContainer includeDivider={includeDivider}>
      <PackageHeroSummary searchQuery={searchQuery} showNights exact />
      <PackagePagePriceWithPointsPlusPaySlider
        charges={charges}
        travellers={{ children, adults, infants }}
        offerId={offer.hotelOffer.id}
      />
    </PriceContainer>
  );
};

export default OfferPrice;
